function runAndLogError<T extends (...args: any[]) => any>(func: T): ReturnType<T> | undefined {
  try {
    return func();
  } catch (error) {
    console.error(`[faroAdaptor: ${func.name}] Faro operation failed:`, error);
    return undefined;
  }
}

const isTestEnv =
  typeof process !== 'undefined' &&
  (process.env.NODE_ENV === 'test' || process.env.VITEST === 'true');

const safeToString = (value: unknown): string => {
  if (value instanceof Set) {
    return `Set(${value.size}) [${[...value].map(safeToString).join(', ')}]`;
  }
  if (value instanceof Map) {
    return `Map(${value.size}) {${[...value.entries()]
      .map(([k, v]) => `[${safeToString(k)} => ${safeToString(v)}]`)
      .join(', ')}}`;
  }
  if (Array.isArray(value)) {
    return `[${value.map(safeToString).join(', ')}]`;
  }
  if (value instanceof Date) {
    return value.toISOString();
  }
  if (typeof value === 'function') {
    return `[Function${value.name ? `: ${value.name}` : ''}]`;
  }
  if (typeof value === 'symbol') {
    return value.toString();
  }
  if (value instanceof Error) {
    return `[Error: ${value.message}]`;
  }
  if (value && typeof value === 'object') {
    try {
      return JSON.stringify(value, null, 2);
    } catch (e) {
      return `[Object with circular ref]`;
    }
  }
  return String(value);
};

const propsToLogStrings = (obj: unknown): Record<string, string> => {
  if (typeof obj !== 'object' || obj === null) return {};

  const result: Record<string, string> = {};
  for (const [key, value] of Object.entries(obj)) {
    result[key] = safeToString(value);
  }
  return result;
};

export { propsToLogStrings, runAndLogError, safeToString, isTestEnv };
